import styled from "styled-components";

export const ChartStyled = styled.div<{ $opacity: number }>`
  opacity: ${({ $opacity }) => ($opacity !== 0 ? "1" : 0)};
`;

export const ChartWrapperStyled = styled.div<{ $horizontalAlignment: string }>`
  justify-content: ${({ $horizontalAlignment = "inherit" }) =>
    $horizontalAlignment};
`;
